import apiConfig from "src/utils/apiConfig";

export const FETCH_DRIVER_ATTEN = "DriverAtten/fetchDriverAttenRequest";
export const FETCH_BLOCK_DRIVER_ATTEN = "DriverAtten/fetchBlockDriverAttenRequest";
export const BLOCKED_CAB = "DriverAtten/BlockedCabRequest";
// export const ACTIVE_CAB = "DriverAtten/ActiveCabRequest";


export const fetchDriverAtten = (
  branchid: string,
  filter?: string,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.GETDRIVERATTEN}?branchid=${encodeURIComponent(branchid)}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_DRIVER_ATTEN,
    payload: apiobject,
  };
};

export const fetchBlockDriverAtten = (
  branchid: string,
  filter?: string,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.GETBLOCKDRIVERATTEN}?branchid=${encodeURIComponent(branchid)}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_BLOCK_DRIVER_ATTEN,
    payload: apiobject,
  };
};

export const BlockedDriver = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.BLOCKEDCAB,
    body: payload,
  };
  return {
    type: BLOCKED_CAB,
    payload: apiObject,
  };
};

// export const ActiveDriver = (payload: any) => {
//   const apiObject: any = {
//     method: 'POST',
//     authentication: true,
//     endpoint: apiConfig.ACTIVECAB,
//     body: payload,
//   };
//   return {
//     type: ACTIVE_CAB,
//     payload: apiObject,
//   };
// };